import { useEffect, useRef } from "react";

import { getPusherClient } from "@helpers/pusher";

const channelListenerCounts = new Map<string, number>();

function usePusher(
  eventChannelName: string,
  event: string,
  callback: (data: any) => void,
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const pusher = getPusherClient();
    if (eventChannelName && event && pusher) {
      const channel = pusher.subscribe(eventChannelName);
      const handleEvent = (data: any) => callbackRef.current(data);
      channel.bind(event, handleEvent);
      channelListenerCounts.set(
        eventChannelName,
        (channelListenerCounts.get(eventChannelName) ?? 0) + 1,
      );

      return function cleanup() {
        channel.unbind(event, handleEvent);

        const remainingListeners =
          (channelListenerCounts.get(eventChannelName) ?? 1) - 1;
        if (remainingListeners === 0) {
          channelListenerCounts.delete(eventChannelName);
          pusher.unsubscribe(eventChannelName);
        } else {
          channelListenerCounts.set(eventChannelName, remainingListeners);
        }
      };
    }
  }, [eventChannelName, event]);
}

export default usePusher;
